module.exports = __webpack_public_path__ + "fonts/SofiaProSemiBold.83ccf251.eot";